import { render } from "./ReportMetricCalloutStrip.vue?vue&type=template&id=dc512ade&scoped=true"
import script from "./ReportMetricCalloutStrip.vue?vue&type=script&lang=js"
export * from "./ReportMetricCalloutStrip.vue?vue&type=script&lang=js"

import "./ReportMetricCalloutStrip.vue?vue&type=style&index=0&id=dc512ade&scoped=true&lang=css"

import exportComponent from "/home/runner/work/etl/etl/outerspace-admin-2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc512ade"]])

export default __exports__